import { render } from "./failure.vue?vue&type=template&id=51ff84f6&scoped=true"
import script from "./failure.vue?vue&type=script&lang=js"
export * from "./failure.vue?vue&type=script&lang=js"

import "./failure.vue?vue&type=style&index=0&id=51ff84f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ff84f6"]])

export default __exports__